import { cva } from 'class-variance-authority';

// Sheets float with a standard 8px gap on every viewport edge. On the top edge
// the gap additionally clears any fixed window chrome via `--app-titlebar-height`:
// the desktop app's main window publishes 32px (`TauriTitlebarHeightVar`,
// APP-7956); everywhere else (web, auxiliary Tauri windows, Storybook) the var
// is unset and the 0px fallback reduces the calc to the plain 8px gap.
const topClearsTitlebar = 'top-[calc(var(--app-titlebar-height,0px)+0.5rem)]';

export const sheetVariants = cva(
  'fixed z-50 flex flex-col gap-4 rounded-xl border border-surface-elevated-border bg-surface-elevated bg-clip-padding p-4 shadow-sheet duration-300 ease-out will-change-[transform,opacity] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 motion-reduce:animate-none',
  {
    variants: {
      side: {
        top: `inset-x-2 ${topClearsTitlebar} h-auto data-[state=closed]:slide-out-to-top-6 data-[state=open]:slide-in-from-top-6`,
        bottom:
          'inset-x-2 bottom-2 h-auto data-[state=closed]:slide-out-to-bottom-6 data-[state=open]:slide-in-from-bottom-6',
        // `start-2` already rests the sheet on inline-start under both directions, but
        // tailwindcss-animate's `slide-{in,out}-{from,to}-{left,right}` utilities are physical
        // (they set a fixed-sign `--tw-enter-translate-x`). Pair them with `rtl:` companions so
        // the slide-in matches the inline edge the sheet rests on. Same shape recommended by
        // the shadcn RTL guide.
        left: `bottom-2 ${topClearsTitlebar} start-2 w-3/4 data-[state=closed]:slide-out-to-left-6 data-[state=open]:slide-in-from-left-6 sm:max-w-sm rtl:data-[state=closed]:slide-out-to-right-6 rtl:data-[state=open]:slide-in-from-right-6`,
        right: `bottom-2 ${topClearsTitlebar} end-2 w-3/4 data-[state=closed]:slide-out-to-right-6 data-[state=open]:slide-in-from-right-6 sm:max-w-sm rtl:data-[state=closed]:slide-out-to-left-6 rtl:data-[state=open]:slide-in-from-left-6`,
      },
    },
    defaultVariants: {
      side: 'right',
    },
  }
);
